import React from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from '../t';
import C from '../colors';

const DeleteConfirmationDialog = inject('dialogStore')(observer(({ dialogStore }) => {
  const { isOpen, closeDialog, confirmAndCloseDialog } = dialogStore;
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div onClick={closeDialog} style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(26,22,20,.45)',
      display: 'grid', placeItems: 'center',
      animation: 'cfadeIn .2s ease-out',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: C.paper, borderRadius: 16,
        padding: '28px 32px',
        width: 360, maxWidth: 'calc(100vw - 48px)',
        border: `1px solid ${C.hair}`,
        boxShadow: '0 24px 56px -16px rgba(26,22,20,.32)',
      }}>
        <div style={{
          width: 40, height: 40, borderRadius: 20,
          background: '#FEE2E2', marginBottom: 16,
          display: 'grid', placeItems: 'center',
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C53C3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 7h16M9 7V4h6v3M6 7l1.2 13a1.5 1.5 0 0 0 1.5 1.4h6.6a1.5 1.5 0 0 0 1.5-1.4L18 7"/>
          </svg>
        </div>

        <div style={{ fontFamily: C.serif, fontSize: 22, fontWeight: 400, color: C.ink, marginBottom: 8 }}>
          {t('Delete')}
        </div>
        <div style={{ fontSize: 14, color: C.ink3, lineHeight: 1.6, marginBottom: 24 }}>
          {dialogStore.text ? t(dialogStore.text) : t('Are you sure you want to delete?')}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button data-testid="dialog-cancel" onClick={closeDialog} style={{
            fontFamily: C.sans, fontSize: 13, fontWeight: 500,
            padding: '9px 18px', borderRadius: 8,
            background: '#fff', color: C.ink2,
            border: `1.5px solid ${C.hair}`,
            cursor: 'pointer',
          }}>{t('Cancel')}</button>
          <button data-testid="dialog-confirm" onClick={confirmAndCloseDialog} style={{
            fontFamily: C.sans, fontSize: 13, fontWeight: 500,
            padding: '9px 18px', borderRadius: 8,
            background: '#C53C3C', color: '#fff',
            border: 'none', cursor: 'pointer',
            boxShadow: '0 1px 0 #a83030, 0 6px 16px -8px rgba(197,60,60,.55)',
          }}>{t('Confirm')}</button>
        </div>
      </div>
    </div>
  );
}));

export default DeleteConfirmationDialog;
